import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import { UserSearchDialogComponent } from '@go-modules/components/dialogs/user-search-dialog/user-search-dialog.component';
import { UserService, userServiceToken } from 'go-modules/models/user/user.service';

@Component({
	selector: 'super-bar',
	templateUrl: './super-bar.component.html',
	styleUrls: ['./super-bar.component.scss'],
	standalone: false
})
export class SuperBarComponent implements OnInit {
	public searchValue: string = '';

	constructor (
		@Inject(selectedServiceToken) public selectedService: SelectedService,
		@Inject(userServiceToken) private userService: UserService,
		private modal: GoModalService,
		private elementRef: ElementRef
	) {}

	public ngOnInit (): void {
		if (!this.userService.currentUser.is_root_user) {
			throw new Error('SuperBar::Not Authorized!');
		}
	}

	public openUserSearch (initialQuery) {
		if (initialQuery?.length > 2) {
			this.modal.open(UserSearchDialogComponent, true, {
				data: {
					initialQuery
				}
			});
		}
	}

	public clearSearch () {
		this.searchValue = '';
		const input = this.elementRef.nativeElement.querySelector('.search-input');
		input?.focus();
	}
}
